import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const SITE = 'GritVue X1™';
const DEFAULT_DESCRIPTION = 'GritVue X1™ hands-free illuminated work glasses. Build your X1 from $29.95 with Clear, Amber or Smoke lenses. Prescription ready. Free U.S. shipping on every order.';
const titles: Record<string, string> = {
  '/': 'GritVue X1™ | Hands-Free Illuminated Work Glasses',
  '/guide': `How to Use Your X1 | ${SITE}`,
  '/track': `Track My Order | ${SITE}`,
  '/activate': `Activate Your X1 | ${SITE}`,
  '/owner': `Owner Center | ${SITE}`,
  '/verify': `Batch Authenticity Check | ${SITE}`,
  '/rewards': `Crew Rewards | ${SITE}`
};
const legalTitles: Record<string, string> = {
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  returns: 'Returns & Refunds',
  shipping: 'Shipping Policy',
  guarantee: 'Warranty & Protection',
  'legal-notice': 'Legal Notice',
  contact: 'Contact Us'
};
function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.content = content;
}

/** Keeps the browser tab title and description professional on every page. */
export function SiteMeta() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    const slug = pathname.startsWith('/legal/') ? pathname.slice(7) : '';
    const title = titles[pathname] ?? (legalTitles[slug] ? `${legalTitles[slug]} | ${SITE}` : SITE);
    document.title = title;
    setMeta('name', 'description', DEFAULT_DESCRIPTION);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', DEFAULT_DESCRIPTION);
    setMeta('property', 'og:site_name', 'GritVue');
  }, [pathname]);
  return null;
}